// /settings/letter-templates/:id — страница письма или общей фразы (`phrase:help`) (042: T019;
// contracts/ui.md, «Страница письма»). Право проверяет общий маршрут раздела. Номер не по форме
// каталога — «Страница не найдена» без запроса к серверу. Сборка страницы из панелей — T045 (H).
import { LetterTemplateIdSchema } from '@kp/contracts';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { LetterTemplatePage } from '../../../features/letter-templates/LetterTemplatePage.tsx';

export const Route = createFileRoute('/_app/_settings/settings/letter-templates/$id')({
  beforeLoad: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- так TanStack Router показывает 404
    if (!LetterTemplateIdSchema.safeParse(params.id).success) throw notFound();
  },
  component: LetterTemplateRoute,
});

function LetterTemplateRoute() {
  const { id } = Route.useParams();
  // Другое письмо — новая страница: черновик прежнего не переносится.
  return <LetterTemplatePage key={id} id={id} />;
}
